var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container",staticStyle:{"height":"100%","position":"relative"}},[_c('chat',{attrs:{"user-list":_vm.list,"from-user":_vm.currentUser}})],1)}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }